<template>
  <el-dialog :visible.sync="visible" :close-on-click-modal="false" width="690px" @close="closeDialog">
    <div slot="title">{{ $t('system::rbac::valueAuth_title') }}</div>
    <div style="display:flex;justify-content:center">
      <el-transfer
        filterable
        :filter-method="filterMethod"
        :filter-placeholder="$t('system::rbac::请输入内容')"
        v-model="list"
        :data="data"
        ref="transfer"
        :titles="[$t('system::rbac::字段值列表'), $t('system::rbac::已选字段值')]"
      ></el-transfer>
    </div>
    <div slot="footer">
      <el-button @click="visible = false">{{ $t('system::rbac::user_cancel') }}</el-button>
      <el-button type="primary" @click="submitForm" :loading="submitLoading">
        {{ $t('system::rbac::user_confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getVauleList, getVauleAuthList, saveVauleAuthList } from '@/server/system'
export default {
  props: {
    value: {},
    roleId: {
      type: [Number, String],
      default: ''
    },
    modelId: {
      type: [Number, String],
      default: ''
    },
    colId: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      visible: false,
      data: [],
      list: [],
      submitLoading: false
    }
  },
  watch: {
    value(val) {
      this.visible = val
    },
    visible(val) {
      this.$emit('input', val)
      if (val) {
        this.data = []
        this.list = []
        this.$refs.transfer.clearQuery('left')
        this.$refs.transfer.clearQuery('right')
        this.getVauleList()
        this.getVauleAuthList()
      }
    }
  },
  methods: {
    filterMethod(query, item) {
      return item.label.includes(query)
    },
    async getVauleList() {
      const data = await getVauleList({ colId: this.colId, roleId: this.roleId, offset: 0, pageSize: 1000 })
      if (data.result.code === this.$code) {
        this.data = data.result.data.map(i => {
          return { label: i, key: i }
        })
      } else {
        this.$message.error(data.result.msg)
      }
    },
    async getVauleAuthList() {
      const data = await getVauleAuthList({ colId: this.colId, roleId: this.roleId, offset: 0, pageSize: 1000 })
      if (data.result.code === this.$code) {
        this.list = data.result.data
      } else {
        this.$message.error(data.result.msg)
      }
    },
    async submitForm() {
      console.log(this.list)
      this.submitLoading = true
      const data = await saveVauleAuthList({ colId: this.colId, canSees: this.list })
      if (data.result.code === this.$code) {
        this.$message.success(this.$t('system::tip::save_success'))
        this.visible = false
      } else {
        this.$message.error(this.$t('system::tip::save_error'))
      }
      this.submitLoading = false
    },
    closeDialog() {}
  }
}
</script>

<style></style>
